import {
    usersCollection,
    groupsCollection,
    postsCollection,
} from "../../config/firebase";

// Algolia Import
import algoliasearch from "algoliasearch";
const client = algoliasearch("HB6LMAES56", "ba093824fe9ca4968e439255c479a820");

// Algolia Indexes
const userIndex = client.initIndex("users");
const groupIndex = client.initIndex("groups");
const eventIndex = client.initIndex("events");
const featuredUserIndex = client.initIndex("featuredUsers");

let state = {
    searchedUsers: [],
    searchedGroups: [],
    searchedEvents: [],
    searchedFeaturedUsers: [],
    loading: false,
    query: "",
};
let getters = {
    searchQuery: (state) => state.query,
    searchLoading: (state) => state.loading,
    searchedUsers: (state) => state.searchedUsers,
    searchedGroups: (state) => state.searchedGroups,
    searchedEvents: (state) => state.searchedEvents,
    searchedFeaturedUsers: (state) => state.searchedFeaturedUsers,
};
let actions = {
    async getSearchedData({ commit }, value) {
        commit("setSearchLoading", true);
        let searchedUsers = [];
        console.log(value.query);
        commit("setSearchQuery", value.query);
        await userIndex
            .search(value.query)
            .then(async ({ hits }) => {
                for (let hit of hits) {
                    let { objectID } = hit;
                    if (objectID != value.user_id) {
                        let snap = await usersCollection.doc(objectID).get();
                        let data = snap.data();
                        searchedUsers.push({ id: snap.id, ...data });
                    }
                }
            })
            .catch((err) => {});
        let searchedGroups = [];
        await groupIndex
            .search(value.query)
            .then(async ({ hits }) => {
                for (let hit of hits) {
                    let { objectID } = hit;
                    console.log(objectID);
                    let snap = await groupsCollection.doc(objectID).get();
                    let data = snap.data();
                    if (Object.keys(data).length > 0)
                        searchedGroups.push({ id: snap.id, ...data });
                }
            })
            .catch((err) => {
                console.log(err);
            });
        let searchedEvents = [];
        await eventIndex
            .search(value.query)
            .then(async ({ hits }) => {
                for (let hit of hits) {
                    let { objectID } = hit;
                    let snap = await postsCollection.doc(objectID).get();
                    let data = snap.data();
                    searchedEvents.push({ id: snap.id, ...data });
                }
            })
            .catch((err) => {
                console.log(err);
            });
        let searchedFeaturedUsers = [];
        await featuredUserIndex
            .search(value.query)
            .then(async ({ hits }) => {
                for (let hit of hits) {
                    let { objectID } = hit;
                    let snap = await usersCollection.doc(objectID).get();
                    let data = snap.data();
                    searchedFeaturedUsers.push({ id: snap.id, ...data });
                }
            })
            .catch((err) => {
                console.log(err);
            });
        commit("setSearchedData", {
            searchedUsers,
            searchedEvents,
            searchedGroups,
            searchedFeaturedUsers,
        });

        commit("setSearchLoading", false);
    },
    async resetGroupsSearch({ commit }, value) {
        let searchedGroups = [];
        console.log("Value", value);
        await groupIndex
            .search(value.query)
            .then(async ({ hits }) => {
                for (let hit of hits) {
                    let { objectID } = hit;
                    let snap = await groupsCollection.doc(objectID).get();
                    let data = snap.data();
                    if (data && Object.keys(data).length > 0)
                        searchedGroups.push({ id: snap.id, ...data });
                }
            })
            .catch((err) => {
                console.log(err);
            });
        commit("setSearchedGroup", searchedGroups);
    },
};
let mutations = {
    setSearchQuery(state, payload) {
        console.log(payload);
        state.query = payload;
    },
    setSearchLoading(state, payload) {
        state.loading = payload;
    },
    setSearchedData(state, payload) {
        state.searchedUsers = payload.searchedUsers;
        state.searchedGroups = payload.searchedGroups;
        state.searchedEvents = payload.searchedEvents;
        state.searchedFeaturedUsers = payload.searchedFeaturedUsers;
    },
    setSearchedGroup(state, payload) {
        state.searchedGroups = payload;
    },
};
export default { state, getters, actions, mutations };
